// 📁 src/hooks/useSpeechVoice.js
import { useEffect, useState } from "react";

export default function useSpeechVoice(preferredLang = "id") {
  const [voices, setVoices] = useState([]);
  const [selectedVoice, setSelectedVoice] = useState(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const loadVoices = () => {
      const availableVoices = window.speechSynthesis.getVoices();
      setVoices(availableVoices);

      // Pilih voice berdasarkan language code (contoh: "id" → Bahasa Indonesia)
      const preferredVoice =
        availableVoices.find((v) => v.lang.startsWith(preferredLang)) ||
        availableVoices.find((v) =>
          v.name.toLowerCase().includes("indonesia")
        ) ||
        null;

      setSelectedVoice(preferredVoice);
      setIsReady(availableVoices.length > 0);
    };

    // Jalankan langsung dan juga saat voices berubah
    window.speechSynthesis.onvoiceschanged = loadVoices;
    loadVoices();

    return () => {
      window.speechSynthesis.onvoiceschanged = null;
    };
  }, [preferredLang]);

  return { voices, selectedVoice, isReady };
}
